import { render, staticRenderFns } from "./PrintDragAside.vue?vue&type=template&id=6b4ddee6&scoped=true"
import script from "./PrintDragAside.vue?vue&type=script&lang=js"
export * from "./PrintDragAside.vue?vue&type=script&lang=js"
import style0 from "./PrintDragAside.vue?vue&type=style&index=0&id=6b4ddee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ddee6",
  null
  
)

export default component.exports